var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.heroSchema.mobileBgColor }, [
    _c(
      "div",
      {
        staticClass: "hero-banner-carousel__container",
        style: { "max-width": _vm.heroSchema.maxWidth }
      },
      [
        _c(
          "div",
          { staticClass: "hero-banner-carousel" },
          [
            _vm.$mq !== "mobile"
              ? _c("hero-banner-carousel-desktop", {
                  attrs: {
                    "hero-schema": _vm.heroSchema,
                    heroArray: _vm.heroArray
                  }
                })
              : _vm._e(),
            _vm.$mq === "mobile"
              ? _c("hero-banner-carousel-mobile", {
                  attrs: {
                    "hero-schema": _vm.heroSchema,
                    heroArray: _vm.heroArray
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }